// Module
var code = "<span data-bind=\"attr: { title: 'Nearest known location at ' + timestampText }\">\r\n    <span data-bind=\"text: latitudeText\"></span>\r\n    &nbsp;\r\n    <span data-bind=\"text: longitudeText\"></span>\r\n</span>";
// Exports
module.exports = code;